import { Asset } from '@/api/generatedApi';
import { useTenants } from '@/services/tenants/useTenants';

export const useMatchLink = (asset?: Asset, minThreshold?: number): string | undefined => {
  const { getPath, getTenantId } = useTenants();
  const crossTenantAsset = asset?.tenantId !== getTenantId();

  if (!asset || asset.type === 'document' || asset.state !== 'finished' || crossTenantAsset) {
    return undefined;
  }

  const searchParameters = new URLSearchParams();
  searchParameters.set('assetId', asset.id);
  searchParameters.set('searchType', asset.type === 'image' ? 'visual' : 'geometric');
  if (minThreshold) {
    searchParameters.set('minThreshold', minThreshold.toString());
  }

  return getPath(`assets?${searchParameters.toString()}`);
};
